/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

export {
  BreakSentenceResultItem,
  BreakSentenceTextInput,
  DetectResultItem,
  DetectTextInput,
  DictionaryExampleResultItem,
  DictionaryExampleResultItemExamplesItem,
  DictionaryExampleTextInput,
  DictionaryLookupResultItem,
  DictionaryLookupResultItemTranslationsItem,
  DictionaryLookupResultItemTranslationsItemBackTranslationsItem,
  DictionaryLookupTextInput,
  ErrorMessage,
  ErrorMessageError,
  LanguagesResult,
  LanguagesResultDictionary,
  LanguagesResultDictionaryLanguageCode,
  LanguagesResultDictionaryLanguageCodeTranslationsItem,
  LanguagesResultTranslation,
  LanguagesResultTranslationLanguageCode,
  LanguagesResultTransliteration,
  LanguagesResultTransliterationLanguageCode,
  LanguagesResultTransliterationLanguageCodeScriptsItem,
  LanguagesResultTransliterationLanguageCodeScriptsItemToScriptsItem,
  TranslateResultAllItem,
  TranslateResultAllItemDetectedLanguage,
  TranslateResultAllItemTranslationsItem,
  TranslateResultAllItemTranslationsItemAlignment,
  TranslateResultAllItemTranslationsItemSentLen,
  TranslateResultAllItemTranslationsItemSentLenSrcSentLenItem,
  TranslateResultAllItemTranslationsItemSentLenTransSentLenItem,
  TranslateResultAllItemTranslationsItemTransliteration,
  TranslateTextInput,
  TransliterateResultItem,
  TransliterateTextInput
} from "../models/mappers";
